export default {
  products: [
    {
      id: 2,
      name: '桂格養氣人蔘',
      image: 'p2_box1.jpg',
    },
    {
      id: 1,
      name: '桂格養氣人蔘雞精',
      image: 'p2_box2.jpg',
    },
    {
      id: 3,
      name: '桂格活靈芝菌絲體滋補液',
      image: 'p2_box3.jpg',
    },
    {
      id: 4,
      name: '桂格5X人蔘濃縮精華飲',
      image: 'p2_box4.jpg',
    },
  ],
  inputs: [
    {
      id: 1,
      type: 'text',
      name: 'name',
      placeholder: '姓名:',
      ref: 'name',
    },
    {
      id: 2,
      type: 'tel',
      name: 'phone',
      placeholder: '手機:',
      ref: 'phone',
    },
    {
      id: 3,
      type: 'text',
      name: 'email',
      placeholder: 'Email:',
      ref: 'email',
    },
  ],
  defaultContents: [
    '親愛的老媽：',
    '今年不常見面，',
    '但卻更想念。',
    '桂格養氣人蔘，',
    '給你好精神。',
    '新年快樂～',
  ],
}
